import { Action, Message } from "types/redux"
import { DocumentsStore } from "types/store"
import { CheckupDocumentPayload, getCheckupVitalsKey } from "./checkup"
import { CustomerDocument } from "./types"
import {
  CUSTOMER_DOCUMENTS_REQUEST,
  CUSTOMER_DOCUMENTS_SUCCESS,
  CUSTOMER_DOCUMENTS_ERROR,
  CUSTOMER_DOCUMENT_PREVIEW_REQUEST,
  CUSTOMER_DOCUMENT_PREVIEW_SUCCESS,
  CUSTOMER_DOCUMENT_PREVIEW_ERROR,
  CUSTOMER_DOCUMENT_PREVIEW_CLEAR,
  DOCUMENTS_REQUEST,
  CHECKUP_DOCUMENT_REQUEST,
  CHECKUP_DOCUMENT_SUCCESS,
  CHECKUP_DOCUMENT_ERROR,
  SEND_DOCUMENTS_ERROR,
  SEND_DOCUMENTS_REQUEST,
  SEND_DOCUMENTS_SUCCESS,
  SEND_CHECKUP_DOCUMENTS_REQUEST,
  SEND_CHECKUP_DOCUMENTS_SUCCESS,
  SEND_CHECKUP_DOCUMENTS_ERROR,
} from "./constants"

const initialStore = {
  loading: false,
  success: false,
  canSendEmail: true,
}

const reducer = (
  store: Partial<DocumentsStore> = initialStore,
  action:
    | Action<{ id: number }>
    | Action<Message>
    | Action<CheckupDocumentPayload>
    | Action<CustomerDocument[]>
    | Action<CustomerDocument>
    | Action<string>
    | Action<undefined>
): Partial<DocumentsStore> => {
  switch (action.type) {
    case CUSTOMER_DOCUMENTS_REQUEST:
      return {
        ...store,
        customerDocumentsLoading: true,
        customerDocumentsMessage: undefined,
      }
    case CUSTOMER_DOCUMENTS_SUCCESS:
      return {
        ...store,
        customerDocumentsLoading: false,
        customerDocuments: action.payload as CustomerDocument[],
      }
    case CUSTOMER_DOCUMENTS_ERROR:
      return {
        ...store,
        customerDocumentsLoading: false,
        customerDocuments: [],
        customerDocumentsMessage: action.payload as Message,
      }
    case CUSTOMER_DOCUMENT_PREVIEW_REQUEST:
      return {
        ...store,
        previewLoading: true,
        previewUrl: undefined,
        customerDocumentsMessage: undefined,
      }
    case CUSTOMER_DOCUMENT_PREVIEW_SUCCESS:
      return {
        ...store,
        previewLoading: false,
        previewUrl: action.payload as string,
      }
    case CUSTOMER_DOCUMENT_PREVIEW_ERROR:
      return {
        ...store,
        previewLoading: false,
        previewUrl: undefined,
        customerDocumentsMessage: action.payload as Message,
      }
    case CUSTOMER_DOCUMENT_PREVIEW_CLEAR:
      return { ...store, previewLoading: false, previewUrl: undefined }
    case CHECKUP_DOCUMENT_REQUEST:
      return {
        ...store,
        loading: true,
        success: false,
        message: undefined,
        checkupVitalsKey: getCheckupVitalsKey(
          (action as Action<CheckupDocumentPayload>).payload,
        ),
      }
    // Another document flow replaces client.documentUrl: the check-up key no longer describes it
    case DOCUMENTS_REQUEST:
      return { ...store, checkupVitalsKey: undefined }
    case CHECKUP_DOCUMENT_SUCCESS:
      return { ...store, loading: false, success: true, message: undefined }
    case CHECKUP_DOCUMENT_ERROR:
      return {
        ...store,
        loading: false,
        success: false,
        message: action?.payload as Message,
      }
    case SEND_DOCUMENTS_REQUEST:
      return { ...store, loading: true, success: false, message: undefined }
    case SEND_DOCUMENTS_SUCCESS:
      return {
        ...store,
        loading: false,
        success: true,
        message: action?.payload as Message,
        canSendEmail: false,
      }
    case SEND_DOCUMENTS_ERROR:
      return {
        ...store,
        loading: false,
        success: false,
        message: action?.payload as Message,
      }
    case SEND_CHECKUP_DOCUMENTS_REQUEST:
      return { ...store, loading: true, success: false, message: undefined }
    case SEND_CHECKUP_DOCUMENTS_SUCCESS:
      return { ...store, loading: false, success: true, message: undefined }
    case SEND_CHECKUP_DOCUMENTS_ERROR:
      return {
        ...store,
        loading: false,
        success: false,
        message: action?.payload as Message,
      }
    default:
      return { ...store }
  }
}
export default reducer
